/* <predictive-search> — Shopify Predictive Search API, debounced 250ms
   (CLAUDE.md ≥ 200ms). Results are rendered server-side by the
   `predictive-search` section via the Section Rendering API. */
class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('.search__results');
    this.status = this.querySelector('.search__status');
    this.section = this.dataset.section || 'predictive-search';
    this.timer = null;
    this.controller = null;
    this.input.addEventListener('input', () => this.debounce());
    this.closest('rowdy-drawer')?.addEventListener('drawer:open', () => this.input.focus({ preventScroll: true }));
  }

  debounce() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.search(), 250);
  }

  async search() {
    const q = this.input.value.trim();
    if (this.controller) this.controller.abort();
    if (q.length < 2) { this.render(''); return; }
    this.controller = new AbortController();
    const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6&section_id=${this.section}`;
    try {
      const res = await fetch(url, { signal: this.controller.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('#shopify-section-' + this.section)?.innerHTML || '';
      this.render(inner);
    } catch (err) {
      if (err.name !== 'AbortError') this.render('');
    }
  }

  render(html) {
    this.results.innerHTML = html;
    const open = html.trim().length > 0;
    this.input.setAttribute('aria-expanded', String(open));
    const count = this.results.querySelector('[data-result-count]')?.dataset.resultCount;
    if (this.status && count !== undefined) this.status.textContent = this.results.querySelector('[data-result-count]').textContent;
  }
}

if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
